import { Link, usePage } from "@inertiajs/react";
import { Box, Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import { my_dashboard_path, entry_my_one_on_one_games_path, my_settings_path, events_path, top_path } from "@/routes";
import { BallIcon, CalendarIcon, CrownIcon, MenuIcon, ProfileIcon } from "@/components/icon";

const Footer = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { url: currentPath } = usePage();

  // スマホサイズでのみ表示
  if (!isMobile) {
    return null;
  }

  const navigationItems = [
    {
      label: "マイページ",
      iconComponent: ProfileIcon,
      path: my_dashboard_path(),
      active: currentPath === my_dashboard_path(),
    },
    {
      label: "1v1",
      iconComponent: BallIcon,
      path: entry_my_one_on_one_games_path(),
      active: currentPath.startsWith(entry_my_one_on_one_games_path()),
    },
    {
      label: "イベント",
      iconComponent: CalendarIcon,
      path: events_path(),
      active: currentPath.startsWith(events_path()),
    },
    {
      label: "ランキング",
      iconComponent: CrownIcon,
      path: top_path(),
      active: currentPath === top_path(),
    },
    {
      label: "メニュー",
      iconComponent: MenuIcon,
      path: my_settings_path(),
      active: currentPath.startsWith(my_settings_path()),
    },
  ];

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg="primary"
      color="white"
      zIndex={1000}
      borderTop="1px solid"
      borderTopColor="whiteAlpha.200"
      shadow="lg"
    >
      <Flex justify="space-around" align="center">
        {navigationItems.map((item, index) => (
          <Link key={index} href={item.path} style={{ textDecoration: "none", color: "inherit" }}>
            <Flex
              direction="column"
              align="center"
              justify="center"
              py={2}
              px={3}
              minH="30px"
              opacity={item.active ? 1 : 0.8}
              _hover={{ opacity: 1 }}
              transition="opacity 0.2s"
              flex="1"
              color={item.active ? "white" : "#6EA3FF"}
            >
              <Box mb={1}>
                <item.iconComponent />
              </Box>
              <Text fontSize="xs">{item.label}</Text>
            </Flex>
          </Link>
        ))}
      </Flex>
    </Box>
  );
};

export default Footer;
